import {
  MdDeleteOutline,
  MdMailOutline,
  MdOutlinePhone,
  MdOutlineSchool,
} from "react-icons/md";
import { ContactListType } from "utils/interfaces";

interface TeacherCardProps {
  teacher: ContactListType;
  deleteAction: (teacher: ContactListType) => void;
}

const TeacherCard: React.FC<TeacherCardProps> = ({ teacher, deleteAction }) => {
  /**
   * Function used to operate on click of the delete button
   */
  const handleDelete = () => {
    deleteAction(teacher);
  };

  return (
    <div className="w-full p-4 bg-white rounded-lg border border-neutral-200 justify-center items-center gap-3 inline-flex">
      <div className="grow shrink basis-0 h-fit justify-start items-center gap-4 flex overflow-hidden">
        <div className="p-1.5 rounded border border-neutral-200 flex-col justify-start items-center gap-1 inline-flex">
          <div className="flex-col justify-start items-center gap-1 flex">
            <MdOutlineSchool className="w-8 h-8 fill-neutral-500 shrink-0" />
            <div className="text-neutral-500 text-[10px] font-normal font-sans uppercase leading-3 tracking-wide">
              Teacher
            </div>
          </div>
        </div>
        <div className="grow shrink basis-0 flex-col justify-start items-start gap-1.5 inline-flex overflow-hidden">
          <div className="grow shrink basis-0 h-[17px] justify-start items-center gap-1 flex w-full">
            <div className="text-neutral-700 text-base font-semibold font-sans leading-[19px] truncate">
              {teacher.firstName} {teacher.lastName}
            </div>
          </div>
          <div className="grow shrink basis-0 h-[17px] justify-start items-center gap-1 flex w-full">
            <MdOutlinePhone className="w-4 h-4 fill-neutral-600 shrink-0" />
            <div className="text-neutral-600 text-sm font-normal font-sans leading-[17px] truncate">
              {teacher.phone}
            </div>
          </div>
          <div className="grow shrink basis-0 h-[17px] justify-start items-center gap-1 flex w-full">
            <MdMailOutline className="w-4 h-4 fill-neutral-600 shrink-0" />
            <div className="text-neutral-600 text-sm font-normal font-sans leading-[17px] truncate">
              {teacher.email}
            </div>
          </div>
        </div>
      </div>
      <button
        className="p-2.5 bg-neutral-50 hover:bg-neutral-100 ease-in-out duration-150 rounded-full backdrop-blur-[32px] justify-center items-center gap-2 flex cursor-pointer"
        onClick={handleDelete}
      >
        <MdDeleteOutline className="w-5 h-5 fill-neutral-700" />
      </button>
    </div>
  );
};

export default TeacherCard;
